<template>
    <div>
        <van-nav-bar
                title="出库查询"
                left-text=""
                right-text="筛选"
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
        />

        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                              style="height: calc(100vh - 100px); overflow: auto;">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <van-cell v-for="item in list" :key="item.outstockId" class="swipewarp"
                              @click="showPopDetail(item)">
                        <van-row gutter="20">
                            <van-col span="14" class="ellipsis">
                                出库单号：{{item.outstockNo}}
                            </van-col>
                            <van-col span="10" class="ellipsisRight">
                                出库日期：{{item.outstockDate |moment("YY-MM-DD")}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20" style="color: #727272">
                            <van-col span="12" class="ellipsis">
                                品名：{{item.cargoName}}
                            </van-col>
                            <van-col span="12" class="ellipsisRight">
                                数量：{{item.actualAmount}}件,{{item.actualWeight}}吨
                            </van-col>
                        </van-row>
                        <van-row gutter="20" style="color: #727272">
                            <van-col span="24" class="ellipsis">
                                车号：{{item.truckNo}}
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </van-pull-refresh>
        </div>

        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'90%'}">
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9000"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.key" label="出库单号" placeholder="出库单号/货主提单号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.truckNo" label="车牌号码" placeholder='车牌号码' autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.from" label="出库日期" readonly="readonly" placeholder="点击选择日期"
                           autocomplete="off" @click="calendarShow=true" label-width="80px" label-align="right"/>
                <van-field :value="selcargoName" readonly name="picker" label="品名" placeholder="点击选择品名"
                           @click="showPicker = true" label-width="80px" label-align="right"/>
                <van-field :value="selcargoMaterName" readonly name="picker" label="材质" placeholder="点击选择材质"
                           @click="showPickerMater = true" label-width="80px" label-align="right"/>
                <!--                <van-field :value="selcargoModelName" readonly name="picker" label="规格" placeholder="点击选择规格"-->
                <!--                           @click="showPickerModel = true" label-width="80px" label-align="right"/>-->
                <van-field :value="selcargoOrnName" readonly name="picker" label="品牌" placeholder="点击选择品牌"
                           @click="showPickerPP = true" label-width="80px" label-align="right"/>

                <van-popup v-model="showPicker" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="品名"
                            show-toolbar
                            :columns="cargocol"
                            @confirm="selCargoId"
                            @cancel="showPicker = false"
                    />
                </van-popup>
                <van-popup v-model="showPickerMater" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="材质"
                            show-toolbar
                            :columns="cargoMatercol"
                            @confirm="selCargoMaterId"
                            @cancel="showPickerMater = false"
                    />
                </van-popup>
                <van-popup v-model="showPickerModel" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="规格"
                            show-toolbar
                            :columns="cargoModelcol"
                            @confirm="selCargoModelId"
                            @cancel="showPickerModel = false"
                    />
                </van-popup>
                <van-popup v-model="showPickerPP" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="品牌"
                            show-toolbar
                            :columns="cargoOrncol"
                            @confirm="selCargoOrgnId"
                            @cancel="showPickerPP = false"
                    />
                </van-popup>
                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>
                <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              :default-date="[new Date((new Date()-30000*60*60*24)),new Date() ]"
                              type="range" @confirm="calendarConfirm"/>
            </div>
        </van-popup>

        <van-popup v-model="showDetail" position="center" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    title=''
                    left-arrow
                    z-index="9000"
                    @click-left="()=>this.showDetail=false"
            />
            <template>
                <div class="dback-all" style="height: calc(100vh - 96px); overflow: auto;">
                    <van-row>
                        <van-col span="12"><h2 class="van-doc-demo-block__title">{{outstockObj.outstockNo}}</h2>
                        </van-col>
                    </van-row>
                    <div class="van-doc-demo-block">
                        <div class="van-cell-group van-hairline--bottom">
                            <div class="van-cell">
                                <div class="van-cell__title"><span>出库日期</span>
                                </div>
                                <div class="van-cell__value bold"><span>{{outstockObj.outstockDate | moment('YYYY-MM-DD')}}</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>出库类型</span></div>
                                <div class="van-cell__value">
                                    <span>{{outstockObj.outstockMode === 10 ? '现货' : '期货'}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>车牌号码</span></div>
                                <div class="van-cell__value bold"><span>{{outstockObj.truckNo}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>驾驶员</span></div>
                                <div class="van-cell__value"><span>{{outstockObj.deliveryName}} {{outstockObj.deliveryPhone}}</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>备注</span></div>
                                <div class="van-cell__value bold"><span>{{outstockObj.remarks}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="van-doc-demo-block">
                        <van-row>
                            <div class="van-cell"
                                 style="background: transparent;padding: 15px 16px 10px 16px;line-height: 16px">
                                <van-col span="12">
                                    <div class="van-cell__title" style="color: #323233;"><span>出库明细</span></div>
                                </van-col>
                                <van-col span="12">
                                    <div class="van-cell__value"><span>合计：{{outstockObj.amount}}件，{{outstockObj.weight}}吨</span>
                                    </div>
                                </van-col>
                            </div>
                        </van-row>

                        <div class="van-cell-group van-hairline--top-bottom" v-for="item in details"
                             :key="item.outstockDetailId">
                            <div class="van-cell">
                                <div class="van-cell__title"><span>车船箱号</span>
                                </div>
                                <div class="van-cell__value bold"><span>{{item.tscNumber}}</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>品名</span></div>
                                <div class="van-cell__value"><span>{{item.cargoName}}/{{item.cargoMaterialName}}/{{item.cargoModelName}}/{{item.cargoOriginName}}</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>货位</span></div>
                                <div class="van-cell__value"><span>{{item.wcode}}/{{item.acode}}/{{item.pcode}}</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>实发数量</span></div>
                                <div class="van-cell__value"><span>{{item.actualAmount}}件/{{parseFloat(item.actualWeight).toFixed(4)}}吨</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="van-address-detail__bottom">
                <van-col span="24">
                    <van-button block size="small" type="info" native-type="submit" class="button"
                                @click="()=>this.showDetail=false">
                        关闭
                    </van-button>
                </van-col>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'
    import {resCode} from "../../utils/tools";

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        data() {
            return {
                list: [],
                loading: true,
                finished: false,
                searchValue: {},
                selcargoName: "",
                selcargoMaterName: "",
                selcargoModelName: "",
                cargoData: [],
                cargocol: [],
                cargoMatercol: [],
                cargoModelcol: [],
                selcargoOrnName: "",
                cargoOrnData: [],
                cargoModelData: [],
                cargoMaterData: [],
                cargoOrncol: [],
                showPickerPP: false,
                showPicker: false,
                showPickerMater: false,
                showPickerModel: false,
                searchShowPop: false,
                isLoading: false,
                page: 1,
                calendarShow: false,
                showDetailpop: false,
                showDetail: false,
                outstockObj: {},
                details: [],
            }
        },
        mounted() {
            this.onLoad();

            let param = {};
            param.ouid = localStorage.getItem("ouid")
            service.selOuCargoG(param).then(res => {
                let data = res.data;
                this.cargoData = data
                for (let i = 0; i < data.length; i++) {
                    this.cargocol.push(data[i].cargoName)
                }
            })
        },
        methods: {
            showPopDetail(item) {
                let param = {
                    outstockId: item.outstockId,
                    outstockMode: item.outstockMode,
                }
                service.selOutStockByIdWechat(param).then(res => {
                    if (res.code === resCode.success) {
                        this.outstockObj = JSON.parse(JSON.stringify(res.data[0]))
                        this.details = res.data

                        let amount = 0
                        let weight = 0
                        this.details.map(it => {
                            if (it.actualAmount != null) {
                                amount += it.actualAmount
                            }
                            if (it.actualWeight != null) {
                                weight += it.actualWeight
                            }
                        })

                        this.outstockObj.amount = amount
                        this.outstockObj.weight = parseFloat(weight).toFixed(4)
                    } else {
                        Toast(res.msg)
                    }
                })

                this.showDetail = true
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            selCargoId(value, index) {
                this.selcargoName = value;
                this.searchValue.cargoId = this.cargoData[index].cargoId
                this.showPicker = false;
                let param = {};
                param.ouid = localStorage.getItem("ouid")
                param.cargoId = this.cargoData[index].cargoId
                service.selCargoMaterialG(param).then(res => {
                    let data = res.data;
                    this.cargoMaterData = data
                    this.cargoMatercol = []
                    for (let i = 0; i < data.length; i++) {
                        this.cargoMatercol.push(data[i].cargoMaterialName)
                    }
                    this.selcargoMaterName = ""
                    this.searchValue.cargoMaterialId = ""
                })
                service.selCargoModelG(param).then(res => {
                    let data = res.data;
                    this.cargoModelData = data
                    this.cargoModelcol = []
                    for (let i = 0; i < data.length; i++) {
                        this.cargoModelcol.push(data[i].cargoModelName)
                    }
                    this.selcargoModelName = ""
                    this.searchValue.cargoModelId = ""
                })
                service.selCargoOriginG(param).then(res => {
                    let data = res.data;
                    this.cargoOrnData = data
                    this.cargoOrncol = []
                    for (let i = 0; i < data.length; i++) {

                        this.cargoOrncol.push(data[i].cargoOriginName)
                    }
                    this.selcargoOrnName = ""
                    this.searchValue.cargoOriginId = ""
                })
            },
            selCargoOrgnId(value, index) {
                this.selcargoOrnName = value;
                this.searchValue.cargoOriginId = this.cargoOrnData[index].cargoOriginId
                this.showPickerPP = false;
            },
            selCargoModelId(value, index) {
                this.selcargoModelName = value;
                this.searchValue.cargoModelId = this.cargoModelData[index].cargoModelId
                this.showPickerModel = false;
            },
            selCargoMaterId(value, index) {
                this.selcargoMaterName = value;
                this.searchValue.cargoMaterialId = this.cargoMaterData[index].cargoMaterialId
                this.showPickerMater = false;
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.searchShowPop = false;
                this.onLoad();
            },
            onLoad() {
                // 用接口的时候，现在还有材质品牌两个条件没加上

                if (this.searchValue.startDate == null && this.searchValue.endDate == null) {
                    this.searchValue.startDate = new Date((new Date() - 30000 * 60 * 60 * 24))
                    this.searchValue.endDate = new Date()
                }
                let param = this.searchValue
                param.limit = 10
                param.page = this.page
                param.ouid = localStorage.getItem("ouid")
                param.customerId = localStorage.getItem("customerId")
                param.cargoOriginNames = this.selcargoOrnName
                param.cargoMaterialNames = this.selcargoMaterName
                param.status = 40

                service.selOutStockWechatP(param).then((res) => {
                    if (res.code === "200") {
                        if (res.data != null && res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        console.log(this.list)
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                }).catch((res) => {
                    this.loading = false;
                    this.finished = true;
                    Toast(res.message)
                });
            },
            searchPop() {
                this.searchShowPop = true;
            },
            onRefresh() {
                this.onLoad();
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date) {
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.from = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.startDate = this.$moment(start).format("YYYY-MM-DD");
                this.searchValue.endDate = this.$moment(end).format("YYYY-MM-DD");

            },
            resetSearch() {
                this.searchValue = {};
                this.selcargoName = "";
                this.selcargoOrnName = "";
                this.selcargoModelName = "";
                this.selcargoMaterName = "";
                this.finished = false
            },
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .editwarp .swipewarp {
        margin-bottom: 10px;
    }

    .contentwarp {
        margin-top: 50px;
        height: calc(100vh - 50px);
    }

    .detailHeader {
        background-color: #1989fa;
        height: 70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .detailLabel {
        color: #727272;
    }

    .detailLabel.detailtitle {
        color: #323233;
        font-weight: bold;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;
    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;
    }

    /deep/ .ewm .van-button--info {
        border: 1px solid #6685a4;
        width: 200px
    }


    .searchwarp[data-v-1405fac1] {
        margin-top: 56px;
    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow {
        vertical-align: middle;
        margin-left: 5px;
    }

    .van-grid {
        padding: 10px;
    }

    /deep/ .van-image__img {
        border: #e4ebf3 1px solid;
    }

    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }

    .van-button--default {
        border: 1px solid #e2e2e2;
    }

    .van-divider {
        margin: 0px !important;
    }


    /deep/ .thmx > .van-row {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row {
        padding-top: 10px;
        padding-bottom: 0;
    }

    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 32px;
    }

    .van-cell {
        padding: 8px 16px;
        font-size: 15px;
    }

    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
    }

    /deep/ .van-cell__title {
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
        width: 90px;
        color: #969799;
    }

    /deep/ .van-cell__value {
        color: #323233;
    }

    /deep/ .van-cell-group.van-hairline--top-bottom {
        margin-bottom: 5px;
    }

    .van-address-detail__bottom {
        position: fixed;
        bottom: 0px;
        left: 0;
        z-index: 999;
        box-sizing: border-box;
        width: 100%;
        padding: 0;
        background-color: #fff;
    }

    /deep/ .van-address-detail__bottom .button {
        height: 50px;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }

    .bold {
        font-weight: bold;
    }
</style>
